<template>
  <el-container height="auto">
    <el-header style="height:50px;">
      <el-container style="padding:0px;margin:0px;">
          <el-main style="padding:0px;margin:0px;overflow:hidden;">
            <el-form ref="form" :inline="true" :model="form" :rules="rules"  label-width="100px">
              <!-- <el-form-item label="应用类别">
              <el-select v-model="form.category" placeholder="请选择类别" disabled>
                <el-option label="患者应用" value="SUBJECT"></el-option>
                <el-option label="研究应用" value="PROJECT"></el-option>
              </el-select>
              </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="onSave" :disabled="form.category==null">保存</el-button>
              </el-form-item>
            </el-form>
          </el-main>
          <el-aside style="width:120px;padding-top:8px;">
            <el-popover
              placement="bottom"
              width="400"
              trigger="click"
              v-model="formtempaltedisplay">
              <div style="padding-right:8px;">
                <el-input
                v-model="search4addtemplate"
                size="media"
                placeholder="可输入表单名称、标签、分享者进行搜索"
                clearable/>
              </div>

              <el-table ref="formTemplates" 
                :data="templateList.filter(data=> !this.search4addtemplate ||
                                  data.name.toLowerCase().includes(this.search4addtemplate.toLowerCase()) ||
                                  (data.tags || '').toLowerCase().includes(this.search4addtemplate.toLowerCase()) ||
                                  (data.hospital || '').toLowerCase().includes(this.search4addtemplate.toLowerCase()) ||
                                  (data.department || '').toLowerCase().includes(this.search4addtemplate.toLowerCase()) ||
                                  (data.username || '').toLowerCase().includes(this.search4addtemplate.toLowerCase())
                )" 
                max-height="333"
              :show-header="false" @row-click="loadTemplate" highlight-current-row>
              
                <el-table-column label="名称">
                  <template slot-scope="scope">
                    <i class="el-icon-tickets"></i>
                    <span v-text="scope.row.name"></span>
                    <br>
                    <span style="font-size:12px;color:#aabbcc">
                      {{scope.row.hospital}}{{scope.row.department}}{{scope.row.username}}{{scope.row.title}}
                    </span>
                    <br>
                    <span v-if="(scope.row.tags|| []).length != 0">
                    <el-tag size="mini"  v-for="(item,index) in scope.row.tags.split(',')" :key="index">{{item}}</el-tag>
                    </span>
                    <span v-else>
                    </span>
                  </template>
                </el-table-column>
              
              </el-table>
              <el-link slot="reference"><i class="el-icon-mouse"></i>用模板快速创建</el-link>
            </el-popover>
          </el-aside>
      </el-container>
    </el-header>
    <el-main style="overflow:hidden;">
      <iframe ref="iframe" :src="editorUrl" frameborder="0" scrolling="yes" name="iframe" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        search4addtemplate:"",
        templateList: [],
        editorUrl: '',
        formtempaltedisplay:false,
        form: {
          name: '',
          //category: {value:'病例应用', label:'SUBJECT'},
          description: '',
          content:'',
          category:this.$route.query["category"],
        },
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            { min: 5, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' }
          ],
          category: [
            { required: true, message: '请选择类别', trigger: 'change' }
          ],
          description: [
            { required: true, message: '请填写备注信息', trigger: 'blur' }
          ]
        }
      }
    },
    mounted(){
      this.loadTemplates();

      window.content = JSON.stringify({
        form: {
                    title: '新建的表单',
                    instruction: '此处显示表单的说明信息',
                    notes: '',
                    version: '',
                    revision: ''
                },
        sections:[
          {"id":"s_1","caption":"新的段落","instruction":"","notes":"","matrixflag":"0","questions":[]}]
      });

      this.editorUrl = 'formeditor/index.html?' + (new Date()).getTime();
    },
    methods: {
      loadTemplates() {
            this.$http.get('form/templates').then((res) => {
              if(!res) return;
              this.templateList = res.data.list;

              
              }
              
              );                                                  
        },

        loadTemplate(row){
            this.$http.get('form/loadtemplate', {params:{id:row.formtemplateid}}).then((res) => { 
                      if(!res) return;
                      this.formtempaltedisplay = false;
                      var info = res.data.info;
                      //console.log(res)
                      window.content = info.content;
                      this.editorUrl = 'formeditor/index.html?' + (new Date()).getTime();
                    }); 
  
        },
      onSave(){
          var str = this.$refs.iframe.contentWindow.Save();
          var formContent = JSON.parse(str);

          this.$http.get('form/checkname', {params:{name:formContent.form.title}}).then((res)=>{
              if(!res) return;

              var id = res.data.formid;

              if(id > 0)
              {
                this.$message({ type:'error', message: '[' + formContent.form.title + ']已经使用过,请使用其他名称.'});
                return;
              }

              this.form.name = formContent.form.title;
              this.form.description = formContent.form.instruction;
              this.form.content = str;
              this.$http.post('form/new', this.form).then((res) => {
                  if(!res) return;

                  this.$message({ type:'success', message:'新表单'+ this.form.name +'创建成功,可继续编辑.'})
                  
                  //跳转到编辑页面
                  this.$router.push({path:'/form/edit',query:{category:this.form.category,id:res.data.info.formid}});
                  //this.goBack(this.form.category);
              }); 
          });


          
      },
      goBack(category) {
        switch(category){
          case "SUBJECT":
            this.$router.push({ name: 'home-subjectform', params: { }})
            break;
          case "PROJECT":
            this.$router.push({ name: 'home-projectform', params: { }})
            break;
          default:
            this.$router.push({ name: 'home-form', params: { }})
            break;
        }

        //this.$router.push({ name: 'home-form', params: { }})
      },
    }
  }
</script>
<style scoped>
iframe {
  width:100%;
  height:100%;
}
</style>